import { LLM_REASONING_ARG_NAME } from './constants'

/**
 * Return the synthetic LLM reasoning argument as a string, if present.
 *
 * Returns `null` when `toolArgs` is not a plain object or the reasoning arg is
 * absent or nullish.
 */
export function extractLlmReasoning(toolArgs: unknown): string | null {
  if (
    typeof toolArgs !== 'object' ||
    toolArgs === null ||
    Array.isArray(toolArgs)
  ) {
    return null
  }
  const rawReasoning = (toolArgs as Record<string, unknown>)[
    LLM_REASONING_ARG_NAME
  ]
  if (rawReasoning === null || rawReasoning === undefined) {
    return null
  }
  return String(rawReasoning)
}
